import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getPaymentMethodInput,
  getPaymentMethodsInput,
  PaymentMethodLiteModel,
  PaymentMethodModel,
} from './model';

export function useGetPaymentMethods(
  input?: getPaymentMethodsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<PaymentMethodLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<PaymentMethodLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['payment-methods', input?.params],
      () =>
        QueryFetchFunction({
          url: 'payment-methods',
          params: input?.params,
        }),
      options,
    ),
    PaymentMethodLiteModel,
  );
}

export function useGetPaymentMethod(
  input?: getPaymentMethodInput,
  options?: UseQueryOptions<ApiResult<PaymentMethodModel>, ApiError>,
): UseQueryResult<ApiResult<PaymentMethodModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['payment-methods', input?.id],
      () =>
        QueryFetchFunction({
          url: `payment-methods/${input?.id}`,
        }),
      options,
    ),
    PaymentMethodModel,
  );
}

export function getPaymentMethodsKey(input?: getPaymentMethodsInput) {
  return ['payment-methods', input?.params];
}

export function getPaymentMethodKey(input?: getPaymentMethodInput) {
  return ['payment-methods', input?.id];
}
